// extracted by mini-css-extract-plugin
export var section = "hero-module--section--1SP7E";
export var head = "hero-module--head--1tKrs";
export var title = "hero-module--title--yjN5a";
export var partnersSuccessStories = "hero-module--partnersSuccessStories--1QajJ";